import React from 'react';
import MetricChangePercent from "@/pages/datalab/components/MetricUpAndDownComponents/MetricChangePercent";
import './index.scss';

interface IMetricChangeBoxProps {
  title?: React.ReactNode;
  change?: number | string | null;
}

// 环比, 同期, 变化率 数据展示
const MetricChangeBox: React.FC<IMetricChangeBoxProps> = (props) => {
  const { title, change, ...rest } = props;
  return (<div className={'dbl-metric-change-box'} {...rest}>
    <div className={'dbl-change-title'}>{title}</div>
    <MetricChangePercent value={change} className={'dbl-change-value'} />
  </div>);
};

export default MetricChangeBox;